import request from '../utils/request';
//数据
export function toOrderList(data) {
  return request({
    url: '/wap/tyOrder/toOrderList.do',
    method: 'post',
    data
  })
}
//新对账
export function toTradeQuery(data) {
  return request({
    url: '/order/toTradeQuery.do',
    method: 'post',
    data
  });
}
//删除订单
export function toDeleterOrder(data) {
  return request({
    url: '/wap/tyOrder/toDeleterOrder.do',
    method: 'post',
    data
  })
}

//取消订单
export function doCancelOrder(data) {
  return request({
    url: '/wap/tyOrder/doCancelOrder.do',
    method: 'post',
    data
  })
}
//订单支付
export function payEnd(data) {
  return request({
    url: '/order/payEnd.do',
    method: 'post',
    data
  })
}

//支付宝对账
export function toTradeQueryZFB2(data) {
  return request({
    url: '/wap/tyOrder/toTradeQueryZFB2.do',
    method: 'post',
    data
  })
}

//微信对账
export function toTradeQueryWX2(data) {
  return request({
    url: '/wap/tyOrder/toTradeQueryWX2.do',
    method: 'post',
    data
  })
}




